<template>
    <div :style="hasMarginTop ? 'margin-top: 150px;' : ''">

        <!--  PRODUCTS table DESKTOP version -->
        <div v-if="isVisible" class="d-none d-sm-block overflow-y-auto max-h-96">
            <table class="w-full">
                <thead class="h-12 bg-lightGray font-bold">
                <tr class="position-sticky top-0 bg-lightGray">
                    <td class="text-center">№</td>
                    <td style="max-width: 200px">{{ $t('product.name') }}</td>
                    <td class="text-center pr-3">{{ $t('amount') }}</td>
                    <td class="text-center pr-3">{{ $t('price') }}</td>
                    <td class="pl-3">{{ $t('sale.sum') }}</td>
                    <td>{{ $t('actions') }}</td>
                </tr>
                </thead>
                <tbody :style="refresh ? 'margin-top: 1px' : ''">
                <tr v-for="(saleProduct, index) of modelForm.saleProductDtos" :key="index" class="h-12">
                    <td class="text-center">{{ index + 1 }}</td>
                    <td class="w-72">
                        <img
                            class="rounded d-none d-lg-inline"
                            :src="saleProduct.product.image ? url + saleProduct.product.image.contentUrl : ''"
                            height="34px"
                            alt=""
                            @click="setModal(saleProduct.product.name, url + saleProduct.product.image.contentUrl)"
                        >
                        <span class="text-main font-bold pl-3 text-xs lg:text-base">{{ getName(saleProduct) }}</span>
                    </td>
                    <td class="text-center py-2">
                        <!--  additional unit of measures  -->
                        <template class="row" v-if="saleProduct.product.additionalUnitOfMeasures.length > 0">
                            <div class="pb-1">
                                <div class="flex pt-1">
                                    <img src="/images/Minus.png" v-if="!saleProduct.isBonus" alt="" class="h-5 lg:h-7 cursor-pointer mr-2" @click="decreaseAmount(saleProduct)">
                                    <input
                                        class="rounded-bl rounded-tl border-0 h-5 lg:h-7 w-12 lg:w-16 bg-mediumGray focus:outline-none text-center text-main font-bold"
                                        v-model.number="saleProduct.quantity"
                                        @input="calcProductAmount(saleProduct)"
                                    >
                                    <span class="h-5 lg:h-7 w-12 lg:w-20 bg-mediumGray rounded-tr rounded-br text-main font-bold flex align-items-center justify-content-center">
                                        {{ showUnitOfMeasure(saleProduct.product.unitOfMeasure) }}
                                    </span>
                                    <img src="/images/Plus.png" v-if="!saleProduct.isBonus" alt="" class="h-5 lg:h-7 cursor-pointer ml-2" @click="increaseAmount(saleProduct)">
                                </div>
                            </div>

                            <div
                                v-for="(unit, i) in saleProduct.product.additionalUnitOfMeasures"
                                :key="i"
                            >
                                <div class="flex mt-2">
                                    <img src="/images/Minus.png" v-if="!saleProduct.isBonus" alt="" class="h-5 lg:h-7 cursor-pointer mr-2" @click="decreaseAmount(saleProduct, unit, i)">
                                    <input
                                        class="rounded-bl rounded-tl border-0 h-5 lg:h-7 w-12 lg:w-16 bg-mediumGray focus:outline-none text-center text-main font-bold"
                                        v-model="unit.quantity"
                                        @input="calcProductAmount(saleProduct, unit)"
                                    >
                                    <span class="h-5 lg:h-7 w-12 lg:w-20 bg-mediumGray w-20 rounded-tr rounded-br text-main font-bold flex align-items-center justify-content-center">
                                        {{ showUnitOfMeasure(unit.unitOfMeasure) }}
                                    </span>
                                    <img src="/images/Plus.png" v-if="!saleProduct.isBonus" alt="" class="h-5 lg:h-7 cursor-pointer ml-2" @click="increaseAmount(saleProduct, unit, i)">
                                </div>
                            </div>
                        </template>

                        <!--  unit of measure  -->
                        <div v-else class="flex">
                            <img src="/images/Minus.png" v-if="!saleProduct.isBonus" alt="" class="h-5 md:h-5 lg:h-7 cursor-pointer mr-2" @click="decreaseAmount(saleProduct)">
                            <input
                                class="rounded-bl rounded-tl border-0 h-5 lg:h-7 w-12 lg:w-16 bg-mediumGray focus:outline-none text-center text-main font-bold"
                                v-model.number="saleProduct.quantity"
                                @input="calcProductAmount(saleProduct)"
                            >
                            <span class="h-5 lg:h-7 bg-mediumGray w-12 lg:w-20 rounded-tr rounded-br text-main font-bold flex align-items-center justify-content-center">
                                 {{ showUnitOfMeasure(saleProduct.product.unitOfMeasure) }}
                            </span>
                            <img src="/images/Plus.png" v-if="!saleProduct.isBonus" alt="" class="h-5 md:h-5 lg:h-7 cursor-pointer ml-2" @click="increaseAmount(saleProduct)">
                        </div>

                        <!--  alert not enough amount of product  -->
                        <span v-if="notEnoughProductId === saleProduct.id" class="text-hoverDenyColor text-xs font-bold">
                            {{ $t('validator.type.notEnoughProductsInWarehouse') }}
                        </span>
                    </td>
                    <td class="text-center">
                        <input
                            class="rounded border-0 h-5 lg:h-7 w-12 lg:w-16 bg-mediumGray text-xs lg:text-base focus:outline-none text-center text-main lg:font-bold lg:mr-2"
                            @input="calcTotalPrice"
                            v-model.number="saleProduct.product.sellingPrice"
                        >
                        <span class="font-bold mt-0.5 text-xs lg:text-base">{{ showCurrencySymbolById(saleProduct.product.sellingPriceCurrency.id) }}</span>
                    </td>
                    <td class="pl-sm-5 pl-md-0 text-xs lg:text-base">
                        <div>
                            {{
                                showCurrencyById(saleProduct.product.sellingPriceCurrency.id, (parseFloat(saleProduct.product.sellingPrice) * (parseFloat(saleProduct.quantity) + parseFloat(saleProduct.addQuantity))))
                            }}
                        </div>
                        <div style="color: green; font-size: 10px"
                             v-if="saleProduct.discountPercent && !saleProduct.isBonus">
                            {{
                                getDiscountProductPercentAmount(saleProduct)
                            }}
                        </div>
                        <div style="color: green; font-size: 10px"
                             v-if="isTaxAvailableInProduct(saleProduct)">
                            {{
                                getTaxProductPercentAmount(saleProduct)
                            }}
                        </div>
                    </td>
                    <td class="text-center">
                        <div v-if="!saleProduct.isBonus" @click="deleteRowTable(index, saleProduct.isBonus)">
                            <img src="/images/Union.png" alt="" class="h-5 lg:h-7 cursor-pointer">
                        </div>
                    </td>
                </tr>
                </tbody>
                <tbody :style="refresh ? 'margin-top: 1px' : ''">
                <tr v-for="(saleService, serviceIndex) of modelForm.saleServiceDtos" :key="serviceIndex">
                    <td class="text-center">{{ serviceIndex + 1 + modelForm.saleProductDtos.length }}</td>
                    <td class="w-72 text-main font-bold pl-3 text-xs lg:text-base">
                        {{ ' ' + saleService.name }}
                        <span>{{ ' ' + '(' + $t('service.title') + ')' }}</span>
                    </td>
                    <td class="text-center py-2">
                        <!--  unit of measure  -->
                        <div class="flex">
                            <img src="/images/Minus.png" alt="" class="h-5 md:h-5 lg:h-7 cursor-pointer mr-2" @click="serviceDecreaseAmount(saleService)">
                            <input
                                class="rounded-bl rounded-tl border-0 h-5 lg:h-7 w-12 lg:w-36 bg-mediumGray focus:outline-none text-center text-main font-bold"
                                v-model.number="saleService.amount"
                                @input="calcTotalPrice()"
                            >
                            <img src="/images/Plus.png" alt="" class="h-5 md:h-5 lg:h-7 cursor-pointer ml-2" @click="serviceIncreaseAmount(saleService)">

                        </div>
                    </td>
                    <td class="text-center">
                        <input
                            class="rounded border-0 h-5 lg:h-7 w-12 lg:w-16 bg-mediumGray text-xs lg:text-base focus:outline-none text-center text-main lg:font-bold lg:mr-2"
                            @input="calcTotalPrice"
                            v-model.number="saleService.price"
                        >
                        <span class="font-bold mt-0.5 text-xs lg:text-base">
                            {{ showCurrencySymbolById(saleService.currency.id) }}
                        </span>
                    </td>
                    <td class="pl-sm-5 pl-md-0 text-xs lg:text-base">
                        <div>
                            {{
                                showCurrencyById(saleService.currency.id, (parseFloat(saleService.price) * parseFloat(saleService.amount)))
                            }}
                        </div>
                    </td>
                    <td class="text-center">
                        <div @click="deleteRowTable(serviceIndex, false, false)">
                            <img src="/images/Union.png" alt="" class="h-5 lg:h-7 cursor-pointer">
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <!--  PRODUCTS table MOBILE version -->
        <div v-if="isVisible" class="d-sm-none overflow-y-auto max-h-96">
            <table :style="refresh ? 'margin-top: 1px' : ''" class="w-full">
                <tbody v-for="(saleProduct, index) of modelForm.saleProductDtos" :key="index">
                <tr class="h-8 text-main text-xs">
                    <td class="pl-3">{{ $t('product.name') }}</td>
                    <td class="pr-3 float-right">{{ saleProduct.product.name }}</td>
                </tr>
                <tr class="h-8 text-main text-xs">
                    <td class="pl-3">{{ $t('amount') }}</td>
                    <td class="pr-3 py-2 float-right">
                            <!--  additional unit of measures  -->
                            <template class="row" v-if="saleProduct.product.additionalUnitOfMeasures.length > 0">
                                <div class="pb-1">
                                    <div class="flex pt-1">
                                        <img src="/images/Minus.png" v-if="!saleProduct.isBonus" alt="" class="h-5 cursor-pointer mr-2" @click="decreaseAmount(saleProduct)">
                                        <input
                                                class="rounded-bl rounded-tl border-0 h-7 bg-mediumGray w-12 focus:outline-none text-center text-main"
                                                v-model.number="saleProduct.quantity"
                                                @input="calcProductAmount(saleProduct)"
                                        >
                                        <span class="h-7 bg-mediumGray w-12 rounded-tr rounded-br text-main flex align-items-center justify-content-center">
                                        {{ showUnitOfMeasure(saleProduct.product.unitOfMeasure) }}
                                    </span>
                                        <img src="/images/Plus.png" v-if="!saleProduct.isBonus" alt="" class="h-5 cursor-pointer ml-2" @click="increaseAmount(saleProduct)">
                                    </div>
                                </div>

                                <div
                                        v-for="(unit, i) in saleProduct.product.additionalUnitOfMeasures"
                                        :key="i"
                                >
                                    <div class="flex mt-2">
                                        <img src="/images/Minus.png" v-if="!saleProduct.isBonus" alt="" class="h-5 cursor-pointer mr-2" @click="decreaseAmount(saleProduct, unit, i)">
                                        <input
                                                class="rounded-bl rounded-tl border-0 h-5 bg-mediumGray w-12 focus:outline-none text-center text-main"
                                                v-model="unit.quantity"
                                                @input="calcProductAmount(saleProduct, unit)"
                                        >
                                        <span class="h-5 bg-mediumGray w-12 rounded-tr rounded-br text-main flex align-items-center justify-content-center">
                                        {{ showUnitOfMeasure(unit.unitOfMeasure) }}
                                    </span>
                                        <img src="/images/Plus.png" v-if="!saleProduct.isBonus" alt="" class="h-5 cursor-pointer ml-2" @click="increaseAmount(saleProduct, unit, i)">
                                    </div>
                                </div>
                            </template>

                            <!--  unit of measure  -->
                            <div v-else class="flex">
                                <img src="/images/Minus.png" v-if="!saleProduct.isBonus" alt="" class="h-5 cursor-pointer mr-1" @click="decreaseAmount(saleProduct)">
                                <input
                                        class="rounded-bl rounded-tl border-0 h-5 bg-mediumGray w-12 focus:outline-none text-center text-main font-bold"
                                        v-model.number="saleProduct.quantity"
                                        @input="calcProductAmount(saleProduct)"
                                >
                                <span class="h-5 bg-mediumGray w-12 rounded-tr rounded-br text-main font-bold flex align-items-center justify-content-center">
                                 {{ showUnitOfMeasure(saleProduct.product.unitOfMeasure) }}
                                </span>
                                <img src="/images/Plus.png" v-if="!saleProduct.isBonus" alt="" class="h-5 cursor-pointer ml-1" @click="increaseAmount(saleProduct)">
                            </div>

                            <!--  alert not enough amount of product  -->
                            <span v-if="notEnoughProductId === saleProduct.id" class="text-hoverDenyColor text-xs font-bold">
                            {{ $t('validator.type.notEnoughProductsInWarehouse') }}
                        </span>
                    </td>
                </tr>
                <tr class="h-8 text-main text-xs">
                    <td class="pl-3">{{ $t('price') }}</td>
                    <td class="pr-3 float-right">
                        <input
                            class="rounded border-0 h-7 bg-mediumGray w-16 focus:outline-none text-center text-main  mr-2"
                            @input="calcTotalPrice"
                            v-model.number="saleProduct.product.sellingPrice"
                        >
                        <span class="mt-0.5">{{ showCurrencySymbolById(saleProduct.product.sellingPriceCurrency.id) }}</span>
                    </td>
                </tr>
                <tr class="h-8 text-main text-xs">
                    <td class="pl-3">{{ $t('sale.sum') }}</td>
                    <td class="pr-3 float-right">
                        <div>
                            {{
                                showCurrencyById(saleProduct.product.sellingPriceCurrency.id, (parseFloat(saleProduct.product.sellingPrice) * (parseFloat(saleProduct.quantity) + parseFloat(saleProduct.addQuantity))))
                            }}
                        </div>
                        <div style="color: green; font-size: 10px"
                             v-if="saleProduct.discountPercent && !saleProduct.isBonus">
                            {{
                                getDiscountProductPercentAmount(saleProduct)
                            }}
                        </div>
                        <div style="color: green; font-size: 10px"
                             v-if="isTaxAvailableInProduct(saleProduct)">
                            {{
                                getTaxProductPercentAmount(saleProduct)
                            }}
                        </div>
                    </td>
                </tr>
                <tr class="h-8 text-main text-xs" style="border-bottom: 2px solid #4e555b">
                    <td class="pl-3 ">{{ $t('actions') }}</td>
                    <td class="pr-3 float-right">
                        <div v-if="!saleProduct.isBonus" @click="deleteRowTable(index, saleProduct.isBonus)">
                            <img src="/images/Union.png" alt="" class="h-5 cursor-pointer">
                        </div>
                    </td>
                </tr>
                </tbody>
                <tbody v-for="(saleService, serviceIndex) of modelForm.saleServiceDtos" :key="serviceIndex">
                <tr class="h-8 text-main text-xs">
                    <td class="pl-3">{{ $t('service.serviceName') }}</td>
                    <td class="pr-3 float-right">{{ saleService.name }}</td>
                </tr>
                <tr class="h-8 text-main text-xs">
                    <td class="pl-3">{{ $t('amount') }}</td>
                    <td class="pr-3 py-2 float-right">
                        <!--  unit of measure  -->
                        <div class="flex">
                            <img src="/images/Minus.png" alt="" class="h-5 md:h-5 lg:h-7 cursor-pointer mr-2" @click="serviceDecreaseAmount(saleService)">
                            <input
                                    class="rounded-bl rounded-tl border-0 h-5 lg:h-7 w-20 bg-mediumGray focus:outline-none text-center text-main font-bold"
                                    v-model.number="saleService.amount"
                                    @input="calcTotalPrice()"
                            >
                            <img src="/images/Plus.png" alt="" class="h-5 md:h-5 lg:h-7 cursor-pointer ml-2" @click="serviceIncreaseAmount(saleService)">

                        </div>
                    </td>
                </tr>
                <tr class="h-8 text-main text-xs">
                    <td class="pl-3">{{ $t('price') }}</td>
                    <td class="pr-3 float-right">
                        <input
                            class="rounded border-0 h-5 lg:h-7 w-12 lg:w-16 bg-mediumGray text-xs lg:text-base focus:outline-none text-center text-main lg:font-bold lg:mr-2"
                            @input="calcTotalPrice"
                            v-model.number="saleService.price"
                        >
                        <span class="mt-0.5 text-xs lg:text-base">
                            {{ showCurrencySymbolById(saleService.currency.id) }}
                        </span>
                    </td>
                </tr>
                <tr class="h-8 text-main text-xs">
                    <td class="pl-3">{{ $t('sale.sum') }}</td>
                    <td class="pr-3 float-right">
                        <div class="">
                            {{
                                showCurrencyById(saleService.currency.id, (saleService.price * saleService.amount))
                            }}
                        </div>
                    </td>
                </tr>
                <tr class="h-8 text-main text-xs" style="border-bottom: 2px solid #4e555b">
                    <td class="pl-3">{{ $t('actions') }}</td>
                    <td class="pr-3 float-right">
                        <div @click="deleteRowTable(serviceIndex, false, false)">
                            <img src="/images/Union.png" alt="" class="h-5 lg:h-7 cursor-pointer">
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <ModalWithPicture id="show_picture" :img="itemImageUrl" :title="itemName"/>
    </div>
</template>

<script>
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import ModalWithPicture from "@/components/html/ModalWithPicture";
import currencyRateMixin from "@/mixin/currencyRateMixin";
import product from "../store/modules/product";
import {mapGetters} from "vuex";

export default {
    name: "ProductListTable",
    computed: {
        ...mapGetters(["getUserCompany"]),
        product() {
            return product
        }
    },
    mixins: [currencyFormatMixin, currencyRateMixin],
    props: {
        hasMarginTop: {
            type: Boolean,
            default: false
        },
        isVisible: {
            type: Boolean,
            default: false
        },
        isNeedRefresh: {
            type: Boolean,
            default: false
        },
        modelForm: {
            type: Object,
            required: true
        },
        doAction: {
            type: Function,
            default: function (item) {
                console.log(item)
            }
        },
        checkForDiscount: {
            type: Function,
            default: function () {
            }
        }
    },
    data() {
        return {
            url: process.env.VUE_APP_API_URL,
            notEnoughProductId: null,
            itemName: '',
            itemImageUrl: '',
            refresh: this.isNeedRefresh
        }
    },
    methods: {
        getName(saleProduct) {
            return this.isTaxAvailableInProduct(saleProduct) ?
                (saleProduct.product.name + ' (' + saleProduct.product.tax.name + ' ' + parseFloat(saleProduct.product.tax.percent) + ' %)') :
                saleProduct.product.name
        },
        calcTaxAmount(amount, percent) {
            return amount * percent / 100
        },
        isTaxAvailableInProduct(saleProduct) {
            return !this.getUserCompany.isTaxInPrice &&
                saleProduct.product.tax !== null &&
                saleProduct.product.tax['@id'] !== this.getUserCompany.tax
        },
        calculatePercentAmount(amount, percent) {
            if (percent === null) {
                percent = 0
            }

            return amount * (100 - percent) / 100
        },
        getDiscountProductPercentAmount(saleProduct) {
            let amount = this.calculatePercentAmount(
                (saleProduct.product.sellingPrice * (saleProduct.quantity + saleProduct.addQuantity)),
                saleProduct.discountPercent
            )

            return this.$t('sale.discount.title') + '-' + saleProduct.discountPercent + '% = ' +
                this.showCurrencyById(
                    saleProduct.product.sellingPriceCurrency.id,
                    amount
                )

        },
        getTaxProductPercentAmount(saleProduct) {
            let amount = this.calcTaxAmount(
                (saleProduct.product.sellingPrice * (saleProduct.quantity + saleProduct.addQuantity)),
                parseFloat(saleProduct.product.tax.percent)
            )

            return this.$t('sale.tax.title') + '+' + parseFloat(saleProduct.product.tax.percent) + '% = ' +
                this.showCurrencyById(
                    saleProduct.product.sellingPriceCurrency.id,
                    amount
                )

        },
        calcProductAmount(piw, unit = null) {
            if (unit === null) {
                if ((piw.quantity + piw.addQuantity) >= piw.amount) {
                    this.notEnoughProductId = piw.id
                }
            } else {
                let amount = 0

                for (let u of piw.product.additionalUnitOfMeasures) {
                    amount += u.howMany * u.quantity
                }

                piw.addQuantity = amount
            }

            if ((piw.quantity + piw.addQuantity) >= piw.amount) {
                this.notEnoughProductId = piw.id
            }

            if ((piw.quantity + piw.addQuantity) < piw.amount) {
                this.notEnoughProductId = null
            }

            this.$emit('calcTotalPrice')
            this.checkForDiscount()
            this.refresh = !this.isNeedRefresh
        },
        increaseAmount(piw, unit = null, index = null) {
            if (unit === null) {
                if (piw.quantity < piw.amount) {
                    piw.quantity++
                } else if (piw.quantity >= piw.amount) {
                    this.notEnoughProductId = piw.id
                }
            } else {
                if (piw.product.additionalUnitOfMeasures[index].howMany + parseInt(piw.quantity) + piw.addQuantity > piw.amount) {
                    this.notEnoughProductId = piw.id
                } else {
                    piw.addQuantity += piw.product.additionalUnitOfMeasures[index].howMany
                    piw.product.additionalUnitOfMeasures[index].quantity++
                }
            }

            this.$emit('calcTotalPrice')
            this.checkForDiscount()
            this.refresh = !this.isNeedRefresh
        },
        serviceIncreaseAmount(service) {
            service.amount++

            this.$emit('calcTotalPrice')
            this.refresh = !this.isNeedRefresh
        },
        serviceDecreaseAmount(service) {
            if (service.amount !== 0) {
                service.amount--

                this.$emit('calcTotalPrice')
                this.refresh = !this.isNeedRefresh
            }
        },
        decreaseAmount(piw, unit = null, index = null) {
            if (unit === null) {
                if (piw.quantity >= 1) {
                    piw.quantity--
                }
            } else {
                if (piw.product.additionalUnitOfMeasures[index].quantity > 0) {
                    piw.addQuantity -= piw.product.additionalUnitOfMeasures[index].howMany
                    piw.product.additionalUnitOfMeasures[index].quantity--
                }
            }

            if (piw.quantity < piw.amount) {
                this.notEnoughProductId = null
            }

            this.$emit('calcTotalPrice')
            this.checkForDiscount()
            this.refresh = !this.isNeedRefresh
        },
        calcTotalPrice() {
            this.$emit('calcTotalPrice')
            this.refresh = !this.isNeedRefresh
        },
        deleteRowTable(index, isBonus = false, isProduct = true) {
            if (isProduct) {
                this.modelForm.saleProductDtos.splice(index, 1)
                if (!isBonus) {
                    this.checkForDiscount()
                }
            } else {
                this.modelForm.saleServiceDtos.splice(index, 1)
            }

        },
        setModal(name, url) {
            this.itemName = name
            this.itemImageUrl = url
            this.$bvModal.show('show_picture')
        },
    },
    watch: {
        'isNeedRefresh'() {
            this.refresh = this.isNeedRefresh
        },
        'refresh'() {
            this.refresh = this.isNeedRefresh
        }
    },
    components: {
        ModalWithPicture
    }
}
</script>

<style scoped>

::-webkit-scrollbar {
    width: 2px;
}

::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #6539B2;
}

.text-light span {
    font-size: 12px;
}

.input-price {
    box-shadow: none !important;
    height: 22px;
    max-width: 100px;
    text-align: center;
}

.list-product .right {
    text-align: right;
}

.list-product .center {
    text-align: center;
}

.input-amount {
    border-top: 1px solid #c5c5c5;
    border-bottom: 1px solid #c5c5c5;
    box-shadow: none !important;
    height: 22px;
}

.mt {
    margin-top: 14px;
}

.minus {
    background-color: #6f42c1;
    cursor: pointer;
    padding-left: 3px;
}

.plus {
    background-color: #6f42c1;
    cursor: pointer;
}

.awesome-icon-amount {
    color: #FFFFFF;
    font-weight: 100;
    font-size: 15px;
}


table tbody tr {
    border-bottom: 1px solid #eaeaea;
}

.delete-row {
    height: 25px;
    width: 25px;
    border: 1px solid #c5c5c5;
    background-color: #6f42c1;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.product-card > span {
    display: flex;
    justify-content: center;
    justify-self: center;
    margin-top: 6px;
}

</style>
